import { MobileBlock } from "@components/mobileBlock/MobileBlock";
import { CheckIcon } from "@icons";
import { FC } from "react";

interface Props {
    heading: string;
}

export const OnboardingMobileBlock: FC<Props> = ({ heading }) => (
    <MobileBlock icon={<CheckIcon />} heading={heading}>
        <p>Kick isn't available on mobile just yet.</p>
        <p>
            To continue setting up your account, please log in on a desktop
            browser.
        </p>
    </MobileBlock>
);
